import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

type InputContainerProps = {
  children: ReactNode;
  type?: 'form' | 'filter';
};

const InputContainer: FC<InputContainerProps> = ({
  children,
  type = 'filter',
}) => {
  const filterStyle = {
    maxWidth: { md: '150px', lg: '200px', xl: '300px' },
    minWidth: { md: '150px', lg: '200px', xl: '300px' },
  };

  const formStyle = {
    maxWidth: { md: '150px', lg: '360px', xl: '360px' },
    minWidth: { md: '150px', lg: '360px', xl: '360px' },
  };

  let style = {};

  switch (type) {
    case 'filter':
      style = filterStyle;
      break;
    case 'form':
      style = formStyle;
      break;
  }
  return <Box sx={style}>{children}</Box>;
};

export default InputContainer;
